import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { currency } from 'app/constants/currency.constants';
import { itemTypeIcons, itemTypeLabel, itemTypePlaceholder } from 'app/constants/itemType.constants';
import { CalculationService, DataService, FormatService, HelperService, HTTPService } from 'app/services';
import { FlatRateSubItem } from 'app/services/sharedInterfaces';
import { messages } from 'app/constants';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

import { findIndex } from 'lodash';

@Component({
  selector: 'app-flat-rate-sub-item',
  templateUrl: './flat-rate-sub-item.component.html',
  styleUrls: ['./flat-rate-sub-item.component.scss'],
})
export class FlatRateSubItemComponent implements OnInit {
  @Input() itemIndex: number = 0;
  @Input() isLast: boolean = false;
  @Input() isCommissionPlanEnabled: boolean = false;
  @Input() isQuickServiceEnabled: boolean = false;
  @Input() partsLookupDropDownList: any[] = [];
  @Input() errors: any = {};
  @Input() companyLocalization: boolean = false;
  @Input() currentLang: string = 'en';
  @Input() defaultSupplierList: any[] = [];
  @Input() subItem: FlatRateSubItem = {
    partTypeId: '',
    itemTitle: '',
    itemId: '',
    code: '',
    type: '',
    title: '',
    titleFR: '',
    description: '',
    descriptionFR: '',
    externalId: '',
    qboId: '',
    isTaxable: false,
    stocked: false,
    cost: 0,
    price: 0,
    count: 0,
    totalCost: 0,
    netSubtotal: 0,
    flatRateAmount: 0,
    tooltip: '',
    supplier: null,
    commissionable: false,
    costEstimatedHours: 0,
    displayDescOnOrder: false,
    displayHoursOnOrder: false,
    isPassThroughTax: false,
    qboItemRefId: '',
    locationQboItemRefId: {},
    category: {},
    salesCode: {},
    tags: [],
    isWarrantyEligible: false,
    warranty: {},
    partSpecification: {},
  };

  @Output() appHandleAdd = new EventEmitter();
  @Output() appHandleDelete = new EventEmitter();
  @Output() appCalculateFlatRateTotal = new EventEmitter();
  @Output() appFetchSupplier = new EventEmitter();

  itemTypeIcons = itemTypeIcons;
  itemTypeLabel = itemTypeLabel;
  itemTypePlaceholder = itemTypePlaceholder;
  itemTypeOptions: any[] = [
    { highlightField: 'part', value: 'part', label: 'Part' },
    { highlightField: 'labor', value: 'labor', label: 'Labor' },
    { highlightField: 'tire', value: 'tire', label: 'Tire' },
    { highlightField: 'fees', value: 'hazmatFee', label: 'Fees' },
  ];
  taxableOptions: any[] = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];
  itemTypeSuggestions: any[] = [];
  itemSuggestions: any[] = [];
  focus: any = {};
  isSearching: boolean = false;
  defaultBillableHours: number = 0;
  usd: string = currency.USD;
  suppliersResults: any[] = [];
  moreDetails: any = {
    supplier: {},
    isTaxable: false,
    commissionable: false,
    displayHoursOnOrder: false,
    displayDescOnOrder: false,
  };
  defaultCostEstimatedHours = 0;

  constructor(
    private dataService: DataService,
    private helperService: HelperService,
    private httpService: HTTPService,
    private calculationService: CalculationService,
    private dialogService: DialogService,
    private formatService: FormatService,
  ) {}

  ngOnInit() {
    if (this.isQuickServiceEnabled) {
      this.itemTypeOptions.splice(findIndex(this.itemTypeOptions, { value: 'part' }) + 1, 0, { highlightField: 'Parts- Lookup', value: 'partLookUp', label: 'Part - Lookup' });
    }
    this.suppliersResults = this.helperService.deepCopy(this.defaultSupplierList);
    this.itemTypeSuggestions = [...this.itemTypeOptions];
    this.moreDetails = {
      supplier: this.subItem.supplier,
      isTaxable: this.subItem.isTaxable,
      commissionable: this.subItem.commissionable,
      displayHoursOnOrder: this.subItem.displayHoursOnOrder,
      displayDescOnOrder: this.subItem.displayDescOnOrder,
    };
    this.defaultBillableHours = this.subItem.count;
  }

  handleFocus(name: string) {
    this.focus[name] = true;
  }

  handleBlur(name: string) {
    this.focus[name] = false;

    if (name === 'title' && !this.subItem.title) {
      this.errors[name] = 'Title is required';
    }
    if (name === 'count' && this.subItem && this.subItem.type === 'labor') {
      // let estimateHours = this.subItem.costEstimatedHours;
      let estimateHours = this.defaultCostEstimatedHours;
      if (estimateHours === 0) {
        estimateHours = this.subItem.count;
      }
      if (this.defaultBillableHours > 0) {
        this.subItem.costEstimatedHours = (Number(this.subItem.count) / Number(this.defaultBillableHours)) * estimateHours;
      }
    }
    this.appCalculateFlatRateTotal.emit();
  }

  handleChange(name: string, value: any) {
    //adding here for ALP-8452 i.e.  If QTY is increased/decreased it will increased/decreased the “Estimated hours“ which will show up on tech app -- start
    let defaultCount = 0;

    //adding here for ALP-8452 i.e.  If QTY is increased/decreased it will increased/decreased the “Estimated hours“ which will show up on tech app -- end
    this.subItem[name] = value;
    this.errors[name] = '';
    //adding here for ALP-8452 i.e.  If QTY is increased/decreased it will increased/decreased the “Estimated hours“ which will show up on tech app -- start

    //adding here for ALP-8452 i.e.  If QTY is increased/decreased it will increased/decreased the “Estimated hours“ which will show up on tech app -- start

    if (this.subItem && this.subItem?.isPassThroughTax && this.subItem?.type === 'hazmatFee') {
      this.subItem.cost = this.subItem[name];
      this.errors['cost'] = '';
    }
  }

  handleMoreDetailChange(key: any, value: any) {
    if (key === 'supplier') {
      this.moreDetails.supplier = {
        supplierId: value._id,
        name: value.name,
      };
    } else {
      this.moreDetails[key] = value;
    }
  }

  handleSearch(name: string, value: string) {
    if (name === 'supplier') {
      this.suppliersResults = [...this.defaultSupplierList.filter(({ name }) => new RegExp(`${value}`, 'gi').test(name))];
    }
  }

  async handleSelect(name: string, value: any) {
    if (name === 'type') {
      this.subItem[name] = value;
      this.focus.title = true;
      this.appHandleAdd.emit();
      if (value === 'partLookUp') {
        this.itemSuggestions = this.partsLookupDropDownList;
      }
    } else if (name === 'title') {
      if (!this.subItem.type) {
        this.appHandleAdd.emit();
      }

      if (value.type === 'partLookUp' && name === 'title') {
        delete this.subItem.itemId;
        value._id = await this.httpService.getObjectId();
        value.category = {};
        this.subItem.partTypeId = value?.partTerminologyID || '';
      }
      this.subItem.itemId = value._id;
      this.subItem.title = value.title;
      this.subItem.titleFR = value.titleFR;
      this.subItem.type = value.type;
      this.subItem.code = value.code;
      this.subItem.description = value.description;
      this.subItem.descriptionFR = value.descriptionFR;
      this.subItem.externalId = value.externalId;
      this.subItem.cost = value.type === 'labor' ? value.costRate : this.formatService.setDynamicCostAndPrice(value, 'cost');
      this.subItem.price = value.type === 'labor' ? value.billRate : this.formatService.setDynamicCostAndPrice(value, 'price');
      this.subItem.count = value.type === 'labor' ? value.billableHours : value.count;
      this.subItem.costEstimatedHours = value.type === 'labor' ? value.costEstimatedHours : 0;
      this.defaultCostEstimatedHours = this.helperService.deepCopy(value.type === 'labor' ? value.costEstimatedHours : 0);
      this.subItem.isTaxable = value.isTaxable;
      this.subItem.commissionable = value.commissionable;
      this.subItem.displayDescOnOrder = value.displayDescOnOrder;
      this.subItem.displayHoursOnOrder = value.displayHoursOnOrder;
      this.subItem.stocked = value.stocked;
      this.subItem.supplier = value.supplier;
      this.subItem.commissionable = value.commissionable;
      this.subItem.qboId = value.qboId;
      this.subItem.isPassThroughTax = value.isPassThroughTax;
      this.subItem.locationQboItemRefId = value.locationQboItemRefId || {};
      this.subItem.qboItemRefId = value.qboItemRefId || '';
      this.subItem.category = value.category || {};
      this.subItem.salesCode = value.salesCode || '';
      this.subItem.tags = [];
      this.subItem.totalCost =
        value.type === 'labor' ? this.calculationService.roundOff(this.subItem.cost * this.subItem.costEstimatedHours) : this.calculationService.roundOff(this.subItem.cost * this.subItem.count);
      this.subItem.netSubtotal = this.calculationService.roundOff(this.subItem.price * this.subItem.count);
      this.focus.isTaxable = true;
      this.defaultBillableHours = this.subItem.count;

      this.moreDetails.supplier = this.subItem.supplier;
      this.moreDetails.isTaxable = this.subItem.isTaxable;
      this.moreDetails.commissionable = this.subItem.commissionable;
      this.moreDetails.displayDescOnOrder = this.subItem.displayDescOnOrder;
      this.moreDetails.displayHoursOnOrder = this.subItem.displayHoursOnOrder;

      if (this.dataService.isPartWarrantiesEnabled && ['part', 'tire'].includes(this.subItem.type)) {
        this.subItem.isWarrantyEligible = value?.isWarrantyEligible || false;
        this.subItem.warranty = {
          warrantySettingId: value?.warranty?.warrantySettingId,
          title: value?.warranty?.title,
        };
      }

      if (value?.partSpecification) {
        this.subItem.partSpecification = this.helperService.deepCopy(value?.partSpecification);
      }

      if (this.dataService.isSalesCodeEnabled && ['part', 'labor', 'tire', 'tireStorage', 'sublet', 'other', 'hazmatFee', 'discount'].includes(this.subItem.type)) {
        this.subItem.tags = this.helperService.updateClassficationServiceItemTag(this.subItem.tags, this.subItem) as [];
      }
    } else if (name === 'isTaxable') {
      this.subItem[name] = value;
    }

    this.errors[name] = '';
    this.appCalculateFlatRateTotal.emit();
  }

  handleDelete() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Delete ${this.subItem.title}`,
        message: `Are you sure you want to delete this ${this.subItem.type}?`,
        button: {
          success: { title: 'Delete', backgroundColor: '#d47877' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.appHandleDelete.emit();
      }
      onClose.unsubscribe();
    });
  }

  handleClear(name: string) {
    if (name === 'type') {
      this.subItem.type = '';
    } else if (name === 'title') {
      this.subItem.title = '';
    }
  }

  handleItemTypeSearch(query: string) {
    this.itemTypeSuggestions = [...this.itemTypeOptions.filter(({ highlightField }) => new RegExp(query, 'i').test(highlightField))];
  }

  async handleItemSearch(query: string = '') {
    if (this.subItem.type === 'partLookUp') {
      if (query) {
        query = query.toLowerCase();

        this.itemSuggestions = this.partsLookupDropDownList.filter((item) => item.name.toLowerCase().includes(query));
      }
    } else if (['part', 'labor', 'tire', 'hazmatFee', ''].includes(this.subItem.type)) {
      try {
        this.isSearching = true;

        const { records = [] } = await this.httpService.getItems({
          limit: 100,
          type: this.subItem.type,
          search: query.trim(),
          searchType: 'flatRate',
        });

        if (records && records.length) {
          this.itemSuggestions = records.map((part: any) => {
            part.cost = this.formatService.setDynamicCostAndPrice(part, 'cost');
            part.price = this.formatService.setDynamicCostAndPrice(part, 'price');
            part.itemTitle = [part.title || '', part.code || ''].filter((str) => str).join(' - ');
            if (this.companyLocalization) {
              part.itemTitleFR = [part.titleFR || '', part.code || ''].filter((str) => str).join(' - ');
              if (part.titleFR && part.titleFR.toLowerCase().includes(query.trim().toLowerCase())) {
                part.searchBy = 'titleFR';
              } else {
                part.searchBy = 'title';
              }
            }

            return part;
          });
        } else {
          this.itemSuggestions = [];
        }
      } catch (err) {
        this.helperService.showToaster('error', err);
      } finally {
        this.isSearching = false;
      }
    }
  }

  highlighedSearchText(text: string, query: string) {
    if (text && query) {
      let str = text.replace(/\s/g, '&nbsp;');

      const regex = new RegExp(`(${query.replace(/\s/g, '&nbsp;')})`, 'ig');
      str = str.replace(regex, `<span class="font-600"><b>$1</b></span>`);
      return str;
    }

    if (text === 'Parts- Lookup') {
      text = `${text}<span class ="ml lookup-image-dropdown-item"></span>`;
    }

    return text;
  }

  handleSaveSupplier(data: any) {
    this.httpService.createSupplier(data).then(
      (supplier: any) => {
        if (supplier) {
          this.helperService.showToaster('success', messages.supplierCreated);
          this.appFetchSupplier.emit();
        }
      },

      (err) => {
        this.helperService.showToaster('error', err.messages);
      },
    );
  }

  handleUpdateSupplier(data: any) {
    this.httpService.updateSupplier(data).then(
      (res: any) => {
        for (let i = 0; i < this.defaultSupplierList.length; i++) {
          if (this.defaultSupplierList[i]._id === res._id) {
            this.defaultSupplierList[i].name = data.name;
            break;
          }
        }

        for (let i = 0; i < this.suppliersResults.length; i++) {
          if (this.suppliersResults[i]._id === res._id) {
            this.suppliersResults[i].name = data.name;
            break;
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleDetailsSave(close: any) {
    this.subItem.supplier = this.moreDetails.supplier;
    this.subItem.isTaxable = this.moreDetails.isTaxable;
    this.subItem.commissionable = this.moreDetails.commissionable;
    this.subItem.displayDescOnOrder = this.moreDetails.displayDescOnOrder;
    this.subItem.displayHoursOnOrder = this.moreDetails.displayHoursOnOrder;

    if (close) close();
  }

  handleDetailsCancel(close: any) {
    this.moreDetails.supplier = this.subItem.supplier;
    this.moreDetails.isTaxable = this.subItem.isTaxable;
    this.moreDetails.commissionable = this.subItem.commissionable;

    if (close) close();
  }
}
